// Layout.tsx
import React from 'react';
import Header from './DrawerLayout';
import { Box } from '@mui/material';
import { useState, useEffect } from 'react';


interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}

interface LayoutProps {
  children: React.ReactNode;
  projectName: ProjectNames[];
  setDefaultProjectName: (newProjectName: string) => void;
  visibleFlag: boolean; multiSelectFlag: boolean; defaultProjectName: string;
}

//interface HeaderProps {
//  children: React.ReactNode; // Define children prop
//}

//const HeaderLayout: React.FC<LayoutProps> = ({ children, }) => {
const HeaderLayout: React.FC<LayoutProps> = ({ projectName, visibleFlag, setDefaultProjectName, multiSelectFlag, defaultProjectName, children, }) => {
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);

  useEffect(() => {
    // Here, we set the projectNamesData to the received projectName
    const filteredProjects = projectName.filter(project => project.project_status !== 'Completed');
    setProjectNamesData(filteredProjects);
  }, [projectName]); // Add projectName to dependency array


  return (
    <Box>
      <Header projectName={projectNamesData}
        visibleFlag={visibleFlag}
        setDefaultProjectName={setDefaultProjectName}
        multiSelectFlag={multiSelectFlag}
        defaultProjectName={defaultProjectName}
      >
        {children}
      </Header>
    </Box>
  );
};

export default HeaderLayout;
